export const ACTION_LABELS = {
  view: "Ver",
  create: "Crear",
  edit: "Editar",
  delete: "Eliminar",
};

export const SENSITIVITY_LABELS = {
  NORMAL: "NORMAL",
  SENSITIVE: "SENSITIVE",
  HIGH_RISK: "HIGH_RISK",
  SYSTEM_ONLY: "SYSTEM_ONLY",
};

export const getRoleTypeLabel = (role = {}) => {
  if (role.is_transition) return "Transición";
  if (role.is_system) return "Sistema";
  return "Personalizado";
};

export const isSystemLockedRole = (role = {}) =>
  Boolean(role.is_system || role.is_transition);

export const canChangeCustomRole = (role = {}) =>
  !isSystemLockedRole(role);

export const roleHasAssignedUsers = (role = {}) =>
  Number(role.users_count || 0) > 0;

// RBAC-CUSTOM-ROLES-03B seccion E: badge visual -- SOLO deriva de
// `is_system` (fuente unica de verdad backend), nunca de nombre de rol.
export const getRoleOwnershipBadge = (role = {}) =>
  role.is_system ? "Sistema" : "Personalizado";

// RBAC-CUSTOM-ROLES-03B seccion K: copia INDEPENDIENTE (nuevo array, sin
// referencias compartidas) de los idpermiso de un rol fuente -- usado tanto
// para precargar la matriz al "Copiar rol existente" como para verificar en
// tests que desmarcar en la copia nunca muta el `roleDetail` original.
export const buildPermissionIdsFromRole = (roleDetail) =>
  (roleDetail?.permissions || []).map((permission) => permission.idpermiso);

export const splitPermissionName = (permissionName = "") => {
  const [moduleKey, ...rest] = String(permissionName).split(".");
  return {
    moduleKey: moduleKey || "otros",
    actionKey: rest.join(".") || "other",
  };
};

export const humanizeKey = (value = "") =>
  String(value)
    .replace(/_/g, " ")
    .replace(/\./g, " ")
    .trim()
    .replace(/\s+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase())
    .replace(/^Modulo\b/, "Módulo")
    .replace(/^Accion\b/, "Acción");

export const getActionLabel = (actionKey = "") =>
  ACTION_LABELS[actionKey] || humanizeKey(actionKey);

export const buildPermissionModules = (permissions = []) => {
  const modulesByKey = {};

  permissions.forEach((permission) => {
    const { moduleKey, actionKey } = splitPermissionName(permission.nombre);
    if (!modulesByKey[moduleKey]) {
      modulesByKey[moduleKey] = {
        key: moduleKey,
        label: humanizeKey(moduleKey),
        permissions: [],
      };
    }
    modulesByKey[moduleKey].permissions.push({
      ...permission,
      moduleKey,
      actionKey,
      actionLabel: getActionLabel(actionKey),
    });
  });

  return Object.values(modulesByKey).map((module) => ({
    ...module,
    permissions: module.permissions.sort((a, b) => {
      const knownA = Object.prototype.hasOwnProperty.call(ACTION_LABELS, a.actionKey);
      const knownB = Object.prototype.hasOwnProperty.call(ACTION_LABELS, b.actionKey);
      if (knownA !== knownB) return knownA ? -1 : 1;
      return a.actionLabel.localeCompare(b.actionLabel);
    }),
  }));
};

export const getPermissionIdByName = (permissions = []) =>
  permissions.reduce((map, permission) => {
    map[permission.nombre] = permission.idpermiso;
    return map;
  }, {});

export const matchesPermissionSearch = (module, searchText = "") => {
  const term = searchText.trim().toLowerCase();
  if (!term) return true;
  return (
    module.label.toLowerCase().includes(term) ||
    module.permissions.some(
      (permission) =>
        permission.nombre.toLowerCase().includes(term) ||
        permission.actionLabel.toLowerCase().includes(term) ||
        String(permission.descripcion || "").toLowerCase().includes(term)
    )
  );
};
